let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8JSWM")).then(() => parcelRequire('jhz3p'));